import moment from 'moment';

export interface DurationInput {
  selectedStartDate?: string;
  selectedEndDate?: string;

  startMonth: string;
  startYear: string;

  endMonth: string;
  endYear: string;

  planEndMonth: string;
  recentPlanYear: string;

  isCustomQueryPage?: boolean;

  MonthMap: Map<string, any>;
}

export const getInitialDuration = ({
  selectedStartDate,
  selectedEndDate,
  startMonth,
  startYear,
  endMonth,
  endYear,
  planEndMonth,
  recentPlanYear,
  isCustomQueryPage,
  MonthMap,
}: DurationInput) => {
  const startDate = selectedStartDate
    ? moment(selectedStartDate, 'YYYY-MM-DD')
    : null;

  const endDate = selectedEndDate
    ? moment(selectedEndDate, 'YYYY-MM-DD')
    : null;

  const minDate = moment(
    `${MonthMap.get(startMonth)?.monthNumber}-01-${startYear}`,
    'MM-DD-YYYY',
  );

  const maxDate = moment(
    `${
      MonthMap.get(isCustomQueryPage ? endMonth : planEndMonth)?.monthNumber
    }-01-${isCustomQueryPage ? endYear : recentPlanYear}`,
    'MM-DD-YYYY',
  ).endOf('month');

  const defaultStartDate = maxDate
    .clone()
    .subtract(11, 'months')
    .startOf('month');

  const localStartDate = startDate ?? moment.max(minDate, defaultStartDate);

  const localEndDate =
    endDate ??
    (maxDate.isAfter(localStartDate.clone().add(11, 'months').endOf('month'))
      ? localStartDate.clone().add(11, 'months').endOf('month')
      : maxDate);

  return {
    startDate: localStartDate,
    endDate: localEndDate,
    minDate,
    maxDate,
  };
};
